import isMotionAllowed from './Utils/isMotionAllowed.js';

export const init = (html) => {
    html.classList.remove('has-motion', 'no-motion');
    if (isMotionAllowed()) {
        html.classList.add('has-motion');
    } else {
        html.classList.add('no-motion');
    }
};
